import { filter, mergeMap, of, timer } from 'rxjs'
import { catchError, retryWhen, switchMap } from 'rxjs/operators'
import { authenticationExpiredOr } from 'Framework/Epic/AuthenticationExpired.js'
import type { Epic } from '../../index.js'
import { Actions } from '../../Slice/index.js'
import { withBlockingRequest } from '../Application/withBlockingRequest.js'
import { serverIsNotAvailable } from '../../../Framework/Epic/ServerNotAvailable.js'
import { startDownload } from '../../../Util/startDownload.js'

const POLL_DELAY_MS = 3000 // Wait 3 seconds before retrying if 202 is returned

export const GetProjectReportEpic: Epic = (action$, state$, { project, ProjectRepository }) =>
  action$.pipe(
    filter(Actions.project.getReportRequest.match),
    mergeMap((action) =>
      withBlockingRequest(
        ProjectRepository.downloadReport(action.payload.projectId, action.payload.settings).pipe(
          switchMap((response) => {
            const statusCode = response.status

            if (statusCode === 202) {
              // Request is still processing, retry after a delay
              return timer(POLL_DELAY_MS).pipe(mergeMap(() => of(action)))
            }

            if (statusCode === 200) {
              // Backend returned a redirect with S3 URL, trigger the download
              const s3DownloadUrl = response.data.link
              startDownload(s3DownloadUrl)
              return of(project.getReportRequestSuccess({ projectId: action.payload.projectId, link: s3DownloadUrl }))
            }

            return of(project.getReportRequestFailure({ error: new Error(`Unexpected response status: ${statusCode}`) }))
          }),
          retryWhen(serverIsNotAvailable()), // Retry on temporary server unavailability
          catchError((error) =>
            authenticationExpiredOr({
              error,
              failedRequest: action.type,
              failureAction: of(project.getReportRequestFailure({ error: error }))
            })
          ),
          catchError((err) => of(project.getReportRequestFailure({ error: err })))
        ),
        'Generating report...',
        'This operation may take a moment, please wait...'
      )
    )
  )
